/* Tab, Oct 29 2026: make the homepage "Pets — Coming soon" slide inert (see assets/tab-pets-inert.css). */
(function () {
  function inert() {
    document.querySelectorAll('.after-ban-slider .c_fs_slide').forEach(function (slide) {
      var label = slide.querySelector('.c_fs_mobile_label');
      var btn = slide.querySelector('a.c_global_button_main');
      if (!btn) return;
      var isPets = (label && /^\s*pets\s*$/i.test(label.textContent)) || /coming\s*soon/i.test(btn.textContent);
      if (!isPets || btn.classList.contains('tab-inert')) return;
      btn.removeAttribute('href');
      btn.classList.add('tab-inert');
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('tabindex', '-1');
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inert); else inert();
})();
